import styled from "@emotion/styled";

export const ThanksHeader = styled.div({
	width: "100%",
	minHeight: "2rem",
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	gap: 16,
	flexWrap: "wrap"
});
